export default __webpack_public_path__ + "static/15-fc20fc3c2ea25990d7f1589b9fb173c7.jpg";